export enum RoleNameEnum {
    Member = "Member",
    MemberPlus = "MemberPlus",
    MemberSwitch = "MemberSwitch",
    Admin = "Admin",
    AdminPlus = "AdminPlus",
    AdminSuper = "AdminSuper",
}
